import { Icons } from "../../../assets/icons";
import { IS_MOBILE } from "../../../constants/breakpoints";

const Icon = ({ name, width = IS_MOBILE ? "1.75rem" : "2rem", height = IS_MOBILE ? "1.75rem" : "2rem", ...props }) => {
    const SvgIcon = Icons[name];

    if (!SvgIcon) {
        return null;
    }

    return <SvgIcon width={width} height={height} {...props} />;
};

export default Icon;
